<template>
  <div class="contactListInnerMain" :style="cssProps">
    <div class="topBar">
      <div class="topBarTitle">
        Mesajı İlet
      </div>
    </div>
    <div class="searchBar">
      <div class="searchBarLeftIcon" />
      <input @keyup="changeSearchKeyWithTimer($event.target.value)" placeholder="Ara">
      <div class="searchBarRightIcon" />
    </div>
    <div class="contactListContainer">
      <div class="letterHeader" v-if="getFilteredGroups().length > 0">
        GRUPLAR
      </div>
      <div class="contactRowWrapper">
        <ContactRow v-for="contact in getFilteredGroups()"
                    :key="contact.ConversationID"
                    :contact="contact"
                    @click.native="forwardMessage(contact)"
                    v-waypoint="waypointOptions"
                    :data-photourl="contact.PhotoURL"
                    :data-visiblename="contact.GroupName"
        />
      </div>

      <div v-for="letter in letters" :key="letter + 'KK'">
        <div class="letterHeader" v-if="getLetterFilteredContacts(letter).length > 0">
          {{ letter }}
        </div>
        <div class="contactRowWrapper">
          <ContactRow v-for="contact in getLetterFilteredContacts(letter)"
                      :key="contact.UserID"
                      :contact="contact"
                      @click.native="forwardMessage(contact)"
                      v-waypoint="waypointOptions"
                      :data-photourl="contact.PhotoURL"
                      :data-visiblename="contact.VisibleName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'
import ContactRow from '@/components/home/leftcolumn/newConversation/ContactRow.vue'
require('@/security.js')
var moment = require('moment')
var CryptoJS = require('crypto-js')

export default {
  mixins: [messageMixin],

  components: {
    ContactRow
  },

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    },
    letters () {
      let a = 'ABCÇDEFGHIİJKLMNOÖPRSŞTUÜVYZ'.split('')
      return a
    }
  },

  data () {
    return {
      searchKey: '',
      searchKeyTemp: '',
      searchDelay: 0,
      waypointOptions: {
        active: true,
        callback: this.onWaypoint,
        options: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: [0, 1]
        }
      }
    }
  },
  methods: {
    onWaypoint (waypoint) {
      if (waypoint.going === 'in' && !waypoint.el.classList.contains('loaded')) {
        let photourl = waypoint.el.dataset.photourl
        if (!photourl || photourl === '') {
          photourl = '/images/nophoto.png'
        }
        waypoint.el.children[0].src = photourl

        let visiblename = waypoint.el.dataset.visiblename
        waypoint.el.children[1].innerHTML = visiblename

        waypoint.el.classList.add('loaded')
      }
    },
    changeSearchKeyWithTimer (searchKey) {
      var vm = this
      if (searchKey !== vm.searchKeyTemp) {
        vm.searchKeyTemp = searchKey
        vm.searchDelay = 3
        vm.changeSearchKeyWithTimer(searchKey)
      } else {
        vm.searchDelay--
        vm.searchDelay = vm.searchDelay < 0 ? 0 : vm.searchDelay
        if (vm.searchDelay > 0) {
          setTimeout(function () {
            if (searchKey === vm.searchKeyTemp) {
              vm.changeSearchKeyWithTimer(vm.searchKeyTemp)
            }
          }, 1000)
        } else {
          vm.searchKey = searchKey
        }
      }
    },

    getFilteredGroups () {
      return this.$store.getters.filteredGroups
        .filter(group => {
          if (this.searchKey === '') {
            return group
          }
          return group.GroupName.toLocaleLowerCase('tr').includes(
            this.searchKey.toLocaleLowerCase('tr')
          )
            ? group
            : null
        })
    },

    getLetterFilteredContacts (letter) {
      return this.$store.getters.filteredContacts
        .filter(
          contact =>
            contact.VisibleName && contact.VisibleName.charAt(0).toLocaleUpperCase('tr') === letter
        )
        .filter(contact => {
          if (this.searchKey === '') {
            return contact.UserID !== this.$store.state.conversation.messageToForward.From ? contact : null
          }
          return contact.VisibleName.toLocaleLowerCase('tr').includes(
            this.searchKey.toLocaleLowerCase('tr')
          ) && contact.UserID !== this.$store.state.conversation.messageToForward.From
            ? contact
            : null
        })
    },

    forwardMessage (contact) {
      var conv
      let messageParameters = this.$store.state.conversation.messageToForward

      let messageToForward = {}
      messageToForward.Body = messageParameters.Body
      messageToForward.MessageType = messageParameters.MessageType
      messageToForward.Status = 0
      messageToForward.MessageID = this.$uuid.v4()
      messageToForward.CreateDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      messageToForward.UpdateDate = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      messageToForward.From = this.$store.state.session.user.UserID
      messageToForward.MediaURLs = messageParameters.MediaURLs

      if (contact.isGroupConversation) {
        messageToForward.To = contact.GroupID
        messageToForward.ConversationID = ''
        messageToForward.isGroup = true

        conv = this.$store.getters.sortedConversations.find(
          c => c.ConversationID === contact.GroupID
        )
      } else {
        var buddyID = contact.UserID
        var n = this.$store.state.session.user.UserID.localeCompare(buddyID)
        var merged =
            n === -1
              ? this.$store.state.session.user.UserID + buddyID
              : buddyID + this.$store.state.session.user.UserID
        var newConvId = CryptoJS.MD5(merged).toString()

        conv = this.$store.getters.sortedConversations.find(
          c => c.ConversationID === newConvId
        )
        if (conv === undefined) {
          conv = {
            ConversationID: newConvId,
            CreateDate: moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
            Status: 0,
            ContactID: buddyID,
            isBuddyWriting: false,
            Contact: this.$store.getters.getUserById(buddyID),
            Messages: []
          }
          this.$store.dispatch('addNewConversation', conv)
        }

        messageToForward.To = contact.UserID
        messageToForward.ConversationID = conv.ConversationID
        messageToForward.isGroup = false
      }
      messageToForward.isForwarded = true
      messageToForward.Type = 'message'
      messageToForward.mv = messageParameters.mv
      messageToForward.DeleteStatus = 0

      this.$store.dispatch('appendMessages', [messageToForward])
      this.$store.dispatch('clearActiveNewMessage')
      this.$store.commit('setActiveConversation', conv)
      if (this.$store.state.ien) {
        // this.$set(messageToForward,'mv',2)//encryption update
        this.em(messageToForward)
      }

      this.sendMessage(messageToForward)
      this.$modal.hide('homepage')
    }
  }
}
</script>

<style lang="less" scoped>
  .contactListInnerMain {
    height: calc(100% - 0px);
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .contactListContainer {
    background-color: rgb(230, 232, 255);
    width: calc(100% - 0px);
    height: calc(100% - 0px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .contactListContainer::-webkit-scrollbar {
    width: 2px;
  }

  .contactListContainer::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
  }

</style>

<style scoped>
  .topBar {
    background-color: var(--topBarColor);
    height: 60px;
    display: flex;
    align-items: flex-end;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .topBarTitle {
    color: white;
    font-size: 16px;
    font-weight: 700;
    margin: 10px;
    line-height: 40px;
  }

  .closeColumnBtn {
    cursor: pointer;
  }

  .closeColumnBtn>img {
    width: 30px;
    height: 30px;
    margin: 10px;
    margin-left: 20px;
  }

  .letterHeader {
  color: var(--fontColor);
    padding: 10px;
    font-weight: 700;
    background-color: #eaeceb;
  }

  .searchBar {
    padding: 5px;
    background-color: #eaeceb;
    border-bottom: 1px solid rgb(209, 209, 209);
    display: flex;
  }

  .searchBar>input {
    border: none;
    flex-grow: 1;
  }

  .searchBar>input:focus {
    outline: none;
  }

  .searchBarLeftIcon {
    background-color: white;
    width: 30px;
    height: 30px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }

  .searchBarRightIcon {
    background-color: white;
    width: 30px;
    height: 30px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .newGroupContainer {
    display: flex;
    padding: 10px;
    align-items: center;
    background-color: white;
    cursor: pointer;
  }

  .newGroupIcon {
    background-color: var(--buttonColor);
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin-right: 10px;
  }

</style>
